export const homeRecentDestinationsStorageKey = "smartguide.openedGuides.v1";

const maxRecentDestinations = 15;

export type HomeRecentDestination = {
    id: string;
    title: string;
    url: string;
    imageUrl?: string | null;
    kind?: string | null;
    logoUrl?: string | null;
};

export function getRecentHomeDestinations(storage: Storage = window.localStorage): HomeRecentDestination[] {
    const rawValue = storage.getItem(homeRecentDestinationsStorageKey);
    if (!rawValue) {
        return [];
    }

    try {
        const parsed = JSON.parse(rawValue);
        if (!Array.isArray(parsed)) {
            return [];
        }

        return parsed
            .map(toRecentDestination)
            .filter((destination): destination is HomeRecentDestination => destination != null)
            .slice(0, maxRecentDestinations);
    } catch {
        return [];
    }
}

export function recordRecentHomeDestination(
    destination: HomeRecentDestination,
    storage: Storage = window.localStorage
): HomeRecentDestination[] {
    const normalizedDestination = toRecentDestination(destination);
    if (normalizedDestination == null) {
        return getRecentHomeDestinations(storage);
    }

    const nextDestinations = [
        normalizedDestination,
        ...getRecentHomeDestinations(storage).filter(recent => recent.id !== normalizedDestination.id)
    ].slice(0, maxRecentDestinations);

    storage.setItem(homeRecentDestinationsStorageKey, JSON.stringify(nextDestinations));

    return nextDestinations;
}

function toRecentDestination(value: unknown): HomeRecentDestination | null {
    if (value == null || typeof value !== "object") {
        return null;
    }

    const item = value as Partial<HomeRecentDestination>;
    if (!hasText(item.id) || !hasText(item.title) || !hasText(item.url)) {
        return null;
    }

    return {
        id: item.id.trim(),
        title: item.title.trim(),
        url: item.url.trim(),
        imageUrl: hasText(item.imageUrl) ? item.imageUrl.trim() : null,
        kind: hasText(item.kind) ? item.kind.trim() : null,
        logoUrl: hasText(item.logoUrl) ? item.logoUrl.trim() : null
    };
}

function hasText(value: unknown): value is string {
    return typeof value === "string" && value.trim().length > 0;
}
